// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { kanaToRomaji } from "./kanaToRomaji";

const levelPromiseCache = {};
let kanjiExampleMeaningsPromise = null;

function fetchJson(path, label) {
    return fetch(`${process.env.PUBLIC_URL}${path}`).then((res) => {
        if (!res.ok) throw new Error(`Failed to load ${label} (status ${res.status})`);
        return res.json();
    });
}

// Each JLPT level's word list is a separate static JSON file (built from
// JMdict + a JLPT tag list), fetched on demand and cached in memory so
// switching levels back and forth doesn't re-fetch. PT-PT meanings live in
// a parallel per-level file keyed by word id, fetched only for PT pages.
export function fetchVocabularyLevel(level, language = "en") {
    const isPt = language === "pt";
    const key = `${level}-${isPt ? "pt" : "en"}`;
    if (!levelPromiseCache[key]) {
        const english = fetchJson(`/vocab-data/n${level}.json`, `N${level} vocabulary`);
        levelPromiseCache[key] = isPt
            ? Promise.all([english, fetchJson(`/vocab-data/pt/n${level}.json`, `N${level} PT vocabulary`)]).then(
                  ([words, ptMeanings]) =>
                      words.map((word) => ({
                          ...word,
                          englishMeanings: word.meanings,
                          meanings: ptMeanings[word.id] ?? word.meanings,
                      }))
              )
            : english;
        levelPromiseCache[key].catch(() => {
            delete levelPromiseCache[key];
        });
    }
    return levelPromiseCache[key];
}

export function wordMatchesMeaning(word, query) {
    return [...(word.meanings || []), ...(word.englishMeanings || [])].some((meaning) =>
        meaning.toLowerCase().includes(query)
    );
}

// Cards show each word's reading with its romaji, e.g. "おくれる (okureru)",
// so learners search by romaji too. The query is expected to be lower-cased
// already, like wordMatchesMeaning's.
export function wordMatchesRomaji(word, query) {
    return kanaToRomaji(word.reading).includes(query);
}

export function fetchKanjiExampleMeaningsPt() {
    if (!kanjiExampleMeaningsPromise) {
        kanjiExampleMeaningsPromise = fetchJson("/vocab-data/pt/kanji-examples.json", "PT kanji examples");
        kanjiExampleMeaningsPromise.catch(() => {
            kanjiExampleMeaningsPromise = null;
        });
    }
    return kanjiExampleMeaningsPromise;
}
